import type { ApplicationTabKey } from './applicationDetailTabStatus';

/**
 * Map Overview alert `service` labels (from overviewServiceOutcomes) to the
 * application-detail tab that owns the source of truth.
 */
export function overviewServiceTabTarget(service: string): ApplicationTabKey | null {
  switch (service.trim()) {
    case 'Device intelligence':
      return 'device';
    case 'Identity':
      return 'identity';
    case 'Income':
      return 'income';
    case 'Employer':
      return 'employer';
    case 'Decision engine':
      return 'decision';
    case 'Loan review':
      return 'loan-review';
    // Application-level decline — detail lives with the credit decision / DE tab.
    case 'Application':
      return 'decision';
    default:
      return null;
  }
}

/** Human label for “Open …” affordances on Overview cards. */
export function applicationTabOpenLabel(key: ApplicationTabKey): string {
  switch (key) {
    case 'device':
      return 'Device intelligence';
    case 'identity':
      return 'Identity';
    case 'income':
      return 'Income';
    case 'decision':
      return 'Decision engine';
    case 'employer':
      return 'Employer';
    case 'loan-review':
      return 'Loan review';
    case 'manual-review':
      return 'Manual review';
    case 'overview':
      return 'Overview';
    default:
      return key;
  }
}
